export default __webpack_public_path__ + "static/media/ballons.a800358c.png";